import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Route, withRouter } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import PropTypes from 'prop-types'

import EmployeeSearchPanel from './EmployeeSearchPanel'
import Employee from '../Employee'

class EmployeeSearchPage extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      }).isRequired,
      url: PropTypes.string
    }).isRequired
  }

  render () {
    const { match } = this.props
    const baseUrl = match.url
    return (
      <DocumentTitle title='Employee search and listing | Atheneum Partners'>
        <div className='expert-search'>
          <EmployeeSearchPanel baseUrl={baseUrl} />
          <div className='expert-search-results'>
            <Route path='/employee-search/employee/:id' component={Employee} />
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default withRouter(observer(EmployeeSearchPage))
